(function() {
    'use strict';

    angular.module('plate')
        .controller('PlateListController', PlateListController);

    PlateListController.$inject = ['$state', 'notificationSrvc', 'lodashService', 'plateDataSrvc', 'plateSrvc', 'plateMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'platePermissionsConst', 'filterQuerySrvc'];

    function PlateListController($state, notificationSrvc, lodashService, plateDataSrvc, plateSrvc, plateMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, platePermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: 0,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.platesRows = [];
        self.platesCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Wymiar x',
            value: 'size_x',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Wymiar y',
            value: 'size_y',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Cena',
            value: 'price',
            type: 'number',
            searchable: true,
            orderable: true
        }];
        self.modelPermissions = platePermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.searchQuery = {
            name: null,
            size_x: null,
            size_y: null,
            price: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getPlates();
        }

        function getPlates(filterObj) {
            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    size_x: self.searchQuery.size_x,
                    size_y: self.searchQuery.size_y,
                    price: self.searchQuery.price,
                    ordering: self.searchQuery.ordering
                };
            }
            return plateDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.platesRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getPlates);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.plate.create');
        }

        function onEdit(row) {
            $state.go('layout.plate.update', { pk: row.pk });
        }

        function onDelete(row) {
            return plateSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", plateMessagesConst.delete);
                lodashService.remove(self.platesRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getPlates();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getPlates();
        }
    }
})();
